import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Slider from "react-slick";
import CategoryGames from "../elements/CategoryGames";
import api from "services/api";
import GameMenu from "elements/GameMenu";
import FavoriteGame from "elements/FavoriteGame";
import Translator, { __ } from "services/Translator";
import useShowUnavailable from "hooks/useShowUnavailable";
import {
  isGameAvailable,
  filterGamesForDisplay,
} from "services/gameAvailability";
export default function FavoriteGames(props) {
  const defaultForm = {
    page: 1,
    triggerSearch: true,
  };
  const [results, setResults] = useState([]);
  const [form, setForm] = useState(defaultForm);
  const [pagination, setPagination] = useState([]);
  // This page renders its own tiles (not GameItem), so it repeats the treatment
  // by hand. No toggle UI here — it has no sort header, it just honours the
  // shared session value.
  const [showUnavailable] = useShowUnavailable();
  const updateForm = (value, field) => {
    setForm({ ...form, [field]: value });
  };

  const getResults = async () => {
    props.setSpinner(true);
    var response = await api.post("/games/favorites", form);
    props.setSpinner(false);
    if (response.status === 200) {
      setResults(response.data.data);
      setPagination(response.data.paginationData);
    } else {
      props.showAlert(null, response.data.message, true);
    }
    updateForm(false, "triggerSearch"); //Ready for next trigger
  };

  useEffect(() => {
    if (form.triggerSearch) {
      getResults();
    }
  }, [form.triggerSearch]);

  const onPageChange = (page) => {
    setForm({ ...form, page: page, triggerSearch: true });
  };

  const visibleResults = filterGamesForDisplay(results, showUnavailable);

  return (
    <section className="game_content_area container">
      <br />
      <br />
      <div className="common_headline">My Games</div>

      <div className="games_list">
        {visibleResults.length > 0 &&
          visibleResults.map((game, index) => (
            // Stable identity, not the array index — the availability filter
            // reflows the list and index keys would carry tile state across games.
            <React.Fragment key={game?.id ?? game?.slug ?? index}>
              <div
                className={
                  "single_game" +
                  (isGameAvailable(game) ? "" : " gameItemBlock--unavailable")
                }
              >
                <div className="game_thumb">
                  <img src={game.game_snapshot_url} />
                  {!isGameAvailable(game) && (
                    <div
                      className="gameItemUnavailable"
                      role="note"
                      aria-label={__(
                        "This game isn't available in your region or currency."
                      )}
                    >
                      <span
                        className="gameItemUnavailable__icon"
                        aria-hidden="true"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="5"
                            y="11"
                            width="14"
                            height="9"
                            rx="2"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <path
                            d="M8 11V8a4 4 0 0 1 8 0v3"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                        </svg>
                      </span>
                      <span className="gameItemUnavailable__copy">
                        {__(
                          "This game isn't available in your region or currency."
                        )}
                      </span>
                    </div>
                  )}
                  <div className="identyText-overview">
                    {/* <h6 className="game_name">{game.game_name}</h6> */}

                    {/* Structural removal, not pointer-events: a <Link> still
                        routes on Enter and stays in the tab order. */}
                    {isGameAvailable(game) && (
                      <div class="game_action">
                        <Link
                          hreflang={Translator.getSelectedLanguage().code}
                          class="game_play_icon"
                          to={"/play/" + game.slug + "/real"}
                        >
                          <i class="fas fa-play"></i>
                        </Link>
                      </div>
                    )}
                    <h3 class="game_provider_name">{game?.provider?.name}</h3>
                    {/* <Link hreflang={Translator.getSelectedLanguage().code}
                          className=" common_button btnType-three"
                          to={"/play/" + game.slug + "/real"}
                        >
                          <span>Play now</span>
                        </Link> */}

                    {/* <Link hreflang={Translator.getSelectedLanguage().code} className="common_button btnType-three" to="#">
                          <span>Play now</span>
                        </Link> */}
                  </div>
                  <FavoriteGame
                    gameid={game.id}
                    is_favorite_game={game.is_favorite_game}
                    {...props}
                  />
                </div>
                <h4 className="game_title">{game.game_name}</h4>
                {/* <div className="mask_layer"></div> */}

                {/* <div className="identyText-overview">
                      <p>{game.game_name}</p>
                    </div> */}
              </div>
            </React.Fragment>
          ))}
      </div>

      <Link
        hreflang={Translator.getSelectedLanguage().code}
        onClick={() => onPageChange(form.page + 1)}
        className="loadMoreBtn d-none"
      >
        Load More
      </Link>
    </section>
  );
}
